import styled from 'styled-components';
import DevTestButtonsContainer from './DevTestButtonsContainer';

const PageWrap = styled.div`
  width: 100%;
  min-width: 280px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  font-family: 'HiraKaku', 'HGGGothicssi', 'Pretendard', 'Noto Sans', sans-serif;
  background-color: ${({ $backgroundColor }) => $backgroundColor || '#000'};
`;

const PageContainer = ({ $backgroundColor, children }) => (
  <PageWrap $backgroundColor={$backgroundColor}>
    {process.env.REACT_APP_ENV === 'dev' && <DevTestButtonsContainer />}
    {children}
  </PageWrap>
);

export default PageContainer;
